// Dependences
export default {
  BASE_URL: 'http://localhost:8080',
  // API_BASE_URL: 'https://colegiosarquidiocesanos.edu.co/sih-retenciones/server/public',
  API_BASE_URL: 'https://api-retenciones.colegiosarquidiocesanos.edu.co',
  DOCUMENT_DIR: '',
  AVATAR_DIR: 'http://181.49.24.2/'
}



// WEBPACK FOOTER //
// ./src/env.js